import AdminRoleExampleConfig from './admin-role-example/AdminRoleExampleConfig'
import GuestRoleExampleConfig from './only-guest-role-example/GuestRoleExampleConfig'
import StaffRoleExampleConfig from './staff-role-example/StaffRoleExampleConfig'

const authRoleExamplesConfigs = [AdminRoleExampleConfig, StaffRoleExampleConfig, GuestRoleExampleConfig]

export default authRoleExamplesConfigs
